import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IHeiStorePictureViewProps } from './hei-store-picture';
import classnames from 'classnames';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';

export default (props: IHeiStorePictureViewProps) => {
    const {
        config: { className, orgUnitNumber, altText },
        context: { request },
        storeName
    } = props;

    const { locale, apiSettings, gridSettings } = request;

    if (!gridSettings) {
        return null;
    }

    const fileName = `Catalogs/${locale}/Store_${orgUnitNumber}_${locale}.jpg`;
    const storeImageUrl = generateImageUrl(fileName, apiSettings);
    const ImageData: Msdyn365.IImageData = { src: storeImageUrl };

    return (
        <div className={classnames('hei-store-picture', className)}>
            <Msdyn365.Image
                className='hei-store-pic'
                altText={altText || storeName}
                title={altText || storeName}
                {...ImageData}
                gridSettings={gridSettings}
                loadFailureBehavior='hide'
                id={`hei-store-picture-${orgUnitNumber}`}
            />
        </div>
    );
};
